module.exports = __webpack_public_path__ + "static/Oral rehabilitation intraoral after-64fa31c0b4c8ed51d43187d911a43d8c.jpg";